import ChartTypeToggle from "../components/ChartTypeToggle";
import { CHART_TYPE_STORAGE_KEY } from "./constants";

const DoraChangeFailureRateHeaderActions = () => (
  <ChartTypeToggle storageKey={CHART_TYPE_STORAGE_KEY} />
);

export default DoraChangeFailureRateHeaderActions;
